/**
 * The Shop's and the Store's tab strips (owner 2026-10-24: "the tabs cannot be scrolled on the X"): the strip is a
 * sideways touch scroller (styles/s3.css), and the lit tab is brought into view by scrolling the strip only — never
 * the sheet, so the strip never moves up or down when a tab is picked (scrollIntoView would also scroll the sheet).
 */

/** The strip's scrollLeft that centres a tab, clamped to what the strip can scroll. */
export function centredScrollLeft(tabLeft: number, tabWidth: number, stripWidth: number, scrollWidth: number): number {
  const max = Math.max(0, scrollWidth - stripWidth);
  return Math.round(Math.max(0, Math.min(max, tabLeft - (stripWidth - tabWidth) / 2)));
}

/** Scrolls `root`'s tab strip sideways until its lit tab is centred (smoothly after a tap, at once on open). */
export function showActiveTab(root: ParentNode, smooth: boolean): void {
  const strip = root.querySelector<HTMLElement>(".k-itabs"), on = strip?.querySelector<HTMLElement>(".k-itab.on");
  if (!strip || !on) return;
  // the tab's place in the strip's content box (the strip need not be its offsetParent)
  const tabLeft = on.getBoundingClientRect().left - strip.getBoundingClientRect().left + strip.scrollLeft;
  const left = centredScrollLeft(tabLeft, on.offsetWidth, strip.clientWidth, strip.scrollWidth);
  if (smooth && typeof strip.scrollTo === "function") strip.scrollTo({ left, behavior: "smooth" });
  else strip.scrollLeft = left;
}
